<ngx-simplebar class="px-3 mx-n3 mb-2" style="height: calc(100vh - calc(70px + 1.5rem + 25px + 125px));"
    [options]="{ forceVisible: true }">
    <div class="row" [@changeContent]="conteudoAtual" (@changeContent.done)="onAnimationDone($event)">
        <ng-container [ngSwitch]="conteudoAtual">
            <div class="col-lg-12" *ngSwitchCase="'conteudo1'">
                <div class="card">
                    <div class="card-body border-top border-top-dashed p-4">
                        <div>
                            <h6 class="text-muted text-uppercase fw-semibold mb-4">
                                {{'t-m-properties.t-reviews' | translate }}
                            </h6>
                            <div>
                                <div>
                                    <div class="bg-light px-3 py-2 rounded-2 mb-2">
                                        <div class="d-flex align-items-center">
                                            <div class="flex-grow-1">
                                                <div
                                                    *ngTemplateOutlet="reusableTemplate; context: { item:{totalScale:propertyReviewData.reviewVisitTotal.avg}  }">
                                                </div>
                                            </div>
                                            <div class="flex-shrink-0">
                                                <h6 class="mb-0">
                                                    <!-- {{propertyReviewData.reviewVisitTotal.avg}} -->
                                                    <div class="badge rounded-pill bg-warning mb-0">
                                                        <i class="mdi mdi-star"></i>
                                                        {{propertyReviewData.reviewVisitTotal.avg}}
                                                    </div>
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-center">
                                        <div class="text-muted">
                                            {{propertyReviewData.reviewVisitTotal.total}}
                                            <span class="fw-medium"></span>
                                            {{'t-m-properties.t-reviews' | translate }}
                                        </div>
                                    </div>
                                </div>

                                <div class="mt-3">
                                    <div class="row align-items-center g-2">
                                        <div class="col-auto">
                                            <div class="p-1">
                                                <h6 class="mb-0">5</h6>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="p-1">
                                                <div class="progress animated-progress progress-sm">
                                                    <div class="progress-bar bg-warning" role="progressbar"
                                                        aria-valuemin="0" aria-valuemax="100"
                                                        [ngStyle]="{'width': propertyReviewData.reviewVisit5.avgper + '%'}"
                                                        [attr.aria-valuenow]="propertyReviewData.reviewVisit5.avgper">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-auto">
                                            <div class="p-1">
                                                <h6 class="mb-0 text-muted">
                                                    {{propertyReviewData.reviewVisit5.total}}</h6>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="row align-items-center g-2">
                                        <div class="col-auto">
                                            <div class="p-1">
                                                <h6 class="mb-0">4</h6>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="p-1">
                                                <div class="progress animated-progress progress-sm">
                                                    <div class="progress-bar bg-warning" role="progressbar"
                                                        aria-valuemin="0" aria-valuemax="100"
                                                        [ngStyle]="{'width': propertyReviewData.reviewVisit4.avgper + '%'}"
                                                        [attr.aria-valuenow]="propertyReviewData.reviewVisit4.avgper">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-auto">
                                            <div class="p-1">
                                                <h6 class="mb-0 text-muted">
                                                    {{propertyReviewData.reviewVisit4.total}}</h6>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="row align-items-center g-2">
                                        <div class="col-auto">
                                            <div class="p-1">
                                                <h6 class="mb-0">3</h6>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="p-1">
                                                <div class="progress animated-progress progress-sm">
                                                    <div class="progress-bar bg-warning" role="progressbar"
                                                        aria-valuemin="0" aria-valuemax="100"
                                                        [ngStyle]="{'width': propertyReviewData.reviewVisit3.avgper + '%'}"
                                                        [attr.aria-valuenow]="propertyReviewData.reviewVisit3.avgper">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-auto">
                                            <div class="p-1">
                                                <h6 class="mb-0 text-muted">
                                                    {{propertyReviewData.reviewVisit3.total}}</h6>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="row align-items-center g-2">
                                        <div class="col-auto">
                                            <div class="p-1">
                                                <h6 class="mb-0">2</h6>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="p-1">
                                                <div class="progress animated-progress progress-sm">
                                                    <div class="progress-bar bg-warning" role="progressbar"
                                                        aria-valuemin="0" aria-valuemax="100"
                                                        [ngStyle]="{'width': propertyReviewData.reviewVisit2.avgper + '%'}"
                                                        [attr.aria-valuenow]="propertyReviewData.reviewVisit2.avgper">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-auto">
                                            <div class="p-1">
                                                <h6 class="mb-0 text-muted">
                                                    {{propertyReviewData.reviewVisit2.total}}</h6>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="row align-items-center g-2">
                                        <div class="col-auto">
                                            <div class="p-1">
                                                <h6 class="mb-0">1</h6>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="p-1">
                                                <div class="progress animated-progress progress-sm">
                                                    <div class="progress-bar bg-warning" role="progressbar"
                                                        aria-valuemin="0" aria-valuemax="100"
                                                        [ngStyle]="{'width': propertyReviewData.reviewVisit1.avgper + '%'}"
                                                        [attr.aria-valuenow]="propertyReviewData.reviewVisit1.avgper">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-auto">
                                            <div class="p-1">
                                                <h6 class="mb-0 text-muted">
                                                    {{propertyReviewData.reviewVisit1.total}}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>




                    </div>
                    <div class="card-body p-4 border-top border-top-dashed" *ngIf="reviens.length>0">
                        <h6 class="text-muted text-uppercase fw-semibold mb-4">

                            <a href="javascript:void(0)" (click)="alterarConteudo()" class="link-primary">
                                <!-- Reviews de clientes -->
                                {{'t-m-properties.t-view-more' | translate }}
                                <i class="ri-arrow-right-line align-bottom ms-1"></i></a>

                        </h6>
                        <!-- Swiper -->
                        <div class="swiper vertical-swiper" style="height: 100px;" #verticalSwiper>
                            <div class="swiper-wrapper">
                                <div class="swiper-slide" *ngFor="let rev of reviens">
                                    <div class="card border border-dashed shadow-none">
                                        <div class="card-body">
                                            <div class="d-flex">
                                                <div class="flex-shrink-0 avatar-sm">
                                                    <div class="avatar-title bg-light rounded">
                                                        <img src="assets/images/users/user-dummy-img.jpg" alt=""
                                                            height="30">
                                                    </div>
                                                </div>
                                                <div class="flex-grow-1 ms-3">
                                                    <div>
                                                        <p class="text-muted mb-1 fst-italic text-truncate-two-lines"
                                                            *ngIf="rev.obs">
                                                            " {{rev.obs}} "
                                                        </p>
                                                        <div
                                                            *ngTemplateOutlet="reusableTemplate; context: { item: rev }">
                                                        </div>

                                                    </div>
                                                    <div class="text-end mb-0 text-muted">
                                                        - <cite title="Source Title">{{rev.contactName}}</cite>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="text-center mt-3 d-none">
                            <a href="javascript:void(0)" (click)="alterarConteudo()" class="link-primary">Ver
                                mais
                                <i class="ri-arrow-right-line align-bottom ms-1"></i></a>
                        </div>
                    </div>

                </div>



            </div>
            <div class="col-lg-12" *ngSwitchCase="'conteudo2'">
                <!-- <div class="card-body p-4 border-top border-top-dashed">
                <h6 class="text-muted text-uppercase fw-semibold">Products Reviews</h6>
            </div> -->
                <div class="card-header border-0">
                    <div class="row g-4">
                        <div class="col-sm-auto">
                            <h6 class="text-muted text-uppercase fw-semibold">{{'t-m-properties.t-customer-reviews' |
                                translate }}</h6>
                        </div>
                        <div class="col-sm mt-2">
                            <div class="d-flex justify-content-sm-end">
                                <div class="search-box ms-2 input-group-sm">
                                    <input type="text" class="form-control" id="searchProductList"
                                        placeholder="{{'t-search' | translate }} ..." [formControl]="searchControl">
                                    <i class="ri-search-line search-icon"></i>
                                </div>
                                <!-- <button type="button" class="btn btn-link waves-effect">
                                Go to general review                            
                            </button> -->
                                <!-- <a href="javascript:void(0)" (click)="alterarConteudo()"
                                class="btn btn-light btn-label right ms-2">
                                <i class="ri-arrow-right-line label-icon align-bottom fs-16 ms-2"></i>
                                Go to general review
                            </a> -->
                                <button class="btn btn-outline-info waves-effect waves-primary btn-sm ms-2"
                                    (click)="alterarConteudo()">
                                    {{'t-m-properties.t-back-to-reviews' | translate }}
                                    <i class="ri-arrow-right-line me-1 align-bottom">
                                    </i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="card-header  border-0">
                <div class="d-flex align-items-center">
                    <h6 class="text-muted text-uppercase fw-semibold">Products Reviews</h6>
                    <div class="flex-shrink-0">
                        <button type="button" class="btn btn-success add-btn" data-bs-toggle="modal" id="create-btn"
                            data-bs-target="#showModal"><i class="ri-add-line align-bottom me-1"></i> Create
                            Order</button>
                        <button type="button" class="btn btn-info"><i
                                class="ri-file-download-line align-bottom me-1"></i>
                            Import</button>
                        <button class="btn btn-soft-danger" onclick="deleteMultiple()"><i
                                class="ri-delete-bin-2-line"></i></button>
                    </div>
                </div>
            </div> -->
                <div class="row">
                    <div class="col-xxl-12" [@listAnimation]="selectedItem ? 'shrunk' : 'full'">
                        <!-- <div class="card-body p-4 border-top border-top-dashed"> -->
                        <!-- <h6 class="text-muted text-uppercase fw-semibold mb-4">Products Reviews</h6> -->
                        <!-- Swiper -->

                        <ngx-simplebar class="px-3 mx-n3 mb-2"
                            style="height: calc(90vh - calc(70px + 1.5rem + 60px + 125px));"
                            [options]="{ forceVisible: true }" #infiniteScrollBar>

                            <div class="card border border-dashed shadow-none item-list" *ngFor="let item of reviens">
                                <div class="card-body " (click)="onSelect(item)"
                                    [ngClass]="{'custom-selected':item?.id === selectedItem?.id}">
                                    <div class="d-flex">
                                        <div class="flex-shrink-0 avatar-sm">
                                            <div class="avatar-title bg-light rounded">
                                                <img src="assets/images/users/user-dummy-img.jpg" alt="" height="30">
                                            </div>
                                        </div>
                                        <div class="flex-grow-1 ms-3">
                                            <div>
                                                <p class="text-muted mb-1 fst-italic">{{ item.obs?+'"'+item.obs+'"':''
                                                    }}
                                                </p>
                                                <div *ngTemplateOutlet="reusableTemplate; context: { item: item }">
                                                </div>
                                            </div>
                                            <div class="text-end mb-0 text-muted">
                                                - <cite title="Source Title">{{ item.contactName }}</cite>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ngx-simplebar>

                        <!-- <div class="text-center mt-3">
                            <a href="javascript:void(0)" (click)="alterarConteudo()" class="link-primary">View All
                                Reviews
                                <i class="ri-arrow-right-line align-bottom ms-1"></i></a>
                        </div> -->
                        <div class="col-lg-12" *ngIf="isLoadMore">
                            <div class="text-center mb-3">
                                <a href="javascript:void(0);" class="text-success"><i
                                        class="mdi mdi-loading mdi-spin fs-20 align-middle me-2"></i>
                                    {{'t-m-properties.t-loading' | translate }}...
                                </a>
                            </div>
                        </div>
                        <!-- </div> -->
                    </div>
                    <div class="col-xxl-3" [@detailAnimation]="selectedItem ? 'visible' : 'hidden'">
                        <div class="row mt-n2 mb-3 mb-sm-0">
                            <div class="col-xxl-12">
                                <div class="d-flex gap-sm-1 float-end">
                                    <button type="button" class="btn btn-soft-secondary btn-icon btn-sm fs-16"
                                        (click)="generatePdf()">
                                        <i class="ri-download-2-line align-bottom"></i>
                                    </button>
                                    <button type="button" class="btn btn-soft-danger btn-icon btn-sm fs-16"
                                        (click)="onClose()">
                                        <i class="ri-close-fill align-bottom"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <ngx-simplebar #simplebarDatails class="px-3 mx-n3 mb-2"
                            style="height: calc(90vh - calc(70px + 1.5rem + 60px + 125px));"
                            [options]="{ forceVisible: true }" *ngIf="selectedItem">
                            <div class="card" id="contact-view-detail" #pdfContent>
                                <div class="row pt-3 px-3">

                                    <div class="col-xxl-8">
                                        <div class="card">
                                            <div class="row g-0">
                                                <div class="col-md-4">
                                                    <img class="rounded img-fluid h-100 object-cover"
                                                        src="{{pathImage}}{{property.image}}" alt="Card image"
                                                        (error)="onImageError($event)">
                                                </div>
                                                <div class="col-md-8">

                                                    <div class="card-body">
                                                        <h5 class="card-text mb-2">{{property.title}}</h5>
                                                        <p class="card-text text-muted">
                                                            {{property.reference}}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div><!-- end card -->
                                    </div>
                                    <div class="col-xxl-4 card-body text-center" *ngIf="agentMain">
                                        <div class="position-relative d-inline-block">
                                            <img [src]="agentMain.agentFile?.length > 0 ? pathProfileImage+agentMain.agentFile: 'assets/images/users/user-dummy-img.jpg'"
                                                alt="" class="avatar-md  img-thumbnail"
                                                (error)="onAgentImageError($event)">
                                            <span
                                                class="contact-active position-absolute rounded-circle bg-success"><span
                                                    class="visually-hidden"></span>
                                            </span>
                                        </div>
                                        <h5 class="mt-2 mb-1">{{agentMain.name}}</h5>
                                        <p class="text-muted">{{property.entity.name}}</p>

                                        <ul class="list-inline mb-0 d-none">
                                            <li class="list-inline-item avatar-xs">
                                                <a href="javascript:void(0);"
                                                    class="avatar-title bg-soft-success text-success fs-15 rounded">
                                                    <i class="ri-phone-line"></i>
                                                </a>
                                            </li>
                                            <li class="list-inline-item avatar-xs">
                                                <a href="javascript:void(0);"
                                                    class="avatar-title bg-soft-danger text-danger fs-15 rounded"
                                                    (click)="generatePdf()">
                                                    <i class="ri-mail-line"></i>
                                                </a>
                                            </li>
                                            <li class="list-inline-item avatar-xs">
                                                <a href="javascript:void(0);"
                                                    class="avatar-title bg-soft-warning text-warning fs-15 rounded">
                                                    <i class="ri-question-answer-line"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="card-body ps-3">
                                    <div class="table-responsive table-card">
                                        <table class="table table-borderless mb-0">
                                            <tbody>
                                                <tr>
                                                    <td class="fw-medium" scope="row">
                                                        <!-- {{'t-proposals.t-reviews'|translate}} -->
                                                    </td>
                                                    <td>
                                                        <div class="badge rounded-pill bg-warning mb-0">
                                                            <i class="mdi mdi-star"></i>
                                                            {{selectedItem.totalScale}}
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="fw-medium" scope="row">
                                                        {{'t-proposals.t-name'|translate}}</td>
                                                    <td>{{selectedItem.contactName}}</td>
                                                </tr>
                                                <!-- 
                                            <tr>
                                                <td class="fw-medium" scope="row">Phone No</td>
                                                <td>414-453-5725</td>
                                            </tr> -->
                                                <tr>
                                                    <td class="fw-medium" scope="row">{{'t-proposals.t-date'|translate}}
                                                    </td>
                                                    <td>{{createDateFormat(selectedItem.createdAt)}} </td>
                                                </tr>
                                                <tr>
                                                    <td class="fw-medium" scope="row">
                                                        <p class="text-muted mb-1 fst-italic">
                                                            "{{'t-m-properties.t-Your-expectations-of-the-property'|translate}}"
                                                        </p>

                                                    </td>
                                                    <td>
                                                        <div
                                                            *ngTemplateOutlet="reusableTemplate; context: { item:{totalScale:selectedItem.rating1}  }">
                                                        </div>

                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="fw-medium" scope="row">
                                                        <p class="text-muted mb-1 fst-italic">
                                                            "{{'t-m-properties.t-the-level-of-interest-in-the-property'|translate}}"
                                                        </p>

                                                    </td>
                                                    <td>
                                                        <div
                                                            *ngTemplateOutlet="reusableTemplate; context: { item: {totalScale:selectedItem.rating2} }">
                                                        </div>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td class="fw-medium" scope="row">
                                                        <p class="text-muted mb-1 fst-italic">
                                                            "{{'t-m-properties.t-property-conditions-in-relation-to-price'|translate}}"
                                                        </p>

                                                    </td>
                                                    <td>
                                                        <div
                                                            *ngTemplateOutlet="reusableTemplate; context: { item: {totalScale:selectedItem.rating3} }">
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="fw-medium" scope="row">
                                                        <p class="text-muted mb-1 fst-italic">
                                                            "{{'t-m-properties.t-location'|translate}}"</p>

                                                    </td>
                                                    <td>
                                                        <div
                                                            *ngTemplateOutlet="reusableTemplate; context: { item: {totalScale:selectedItem.rating4} }">
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="fw-medium" scope="row">
                                                        <p class="text-muted mb-1 fst-italic">
                                                            "{{'t-m-properties.t-your-interest-in-making-an-offer'|translate}}"
                                                        </p>

                                                    </td>
                                                    <td>
                                                        <div
                                                            *ngTemplateOutlet="reusableTemplate; context: { item: {totalScale:selectedItem.rating6} }">
                                                        </div>
                                                    </td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-xxl-12">
                                            <h6 class="text-muted mt-4 st-italic">
                                                {{'t-m-properties.t-what-did-you-capture-in-the-advertisement'|translate}}
                                            </h6>
                                            <ul
                                                class="ps-3 list-unstyled vstack gap-2 details-disabled-check text-muted st-italic">
                                                <li>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="checkbox" value=""
                                                            id="photoD"
                                                            [attr.checked]="selectedItem.rating51?true:null">
                                                        <label class="form-check-label" for="photoD">
                                                            {{'t-m-properties.t-photo'|translate}}
                                                        </label>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="form-check ">
                                                        <input class="form-check-input" type="checkbox" value=""
                                                            id="priceD"
                                                            [attr.checked]="selectedItem.rating52?true:null">
                                                        <label class="form-check-label " for="priceD">
                                                            {{'t-m-properties.t-price'|translate}}
                                                        </label>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="checkbox" value=""
                                                            id="locationD"
                                                            [attr.checked]="selectedItem.rating53?true:null">
                                                        <label class="form-check-label" for="locationD">
                                                            {{'t-m-properties.t-location'|translate}}
                                                        </label>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-xxl-12">
                                            <h6 class="text-muted mt-2 st-italic">
                                                {{'t-m-properties.t-how-did-you-get-to-us'|translate}}
                                            </h6>
                                            <p class="text-muted mb-4">
                                                {{selectedItem.rating7}}
                                            </p>
                                        </div>
                                        <div class="col-xxl-12" *ngIf="selectedItem.obs">
                                            <h6 class="text-muted text-uppercase fw-semibold mt-4">OBS</h6>
                                            <p class="text-muted mb-3">
                                                {{selectedItem.obs}}
                                            </p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <!--end card-->
                        </ngx-simplebar>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</ngx-simplebar>

<ng-template #reusableTemplate let-item="item">
    <div class="fs-11 align-middle text-warning">
        <i class="ri-star-fill" [ngClass]="{
                                     'ri-star-fill':item.totalScale>0.75, 
                                     'ri-star-line':item.totalScale<=0.24,
                                      'ri-star-half-fill':item.totalScale>=0.25 && item.totalScale<=0.75
                                 }">
        </i>
        <i class="ri-star-fill" [ngClass]="{
                                    'ri-star-fill':item.totalScale>1.75, 
                                    'ri-star-line':item.totalScale<=1.24,
                                     'ri-star-half-fill':item.totalScale>=1.25 && item.totalScale<=1.75
                                }">
        </i>
        <i class="ri-star-fill" [ngClass]="{
                                    'ri-star-fill':item.totalScale>2.75, 
                                    'ri-star-line':item.totalScale<=2.24,
                                     'ri-star-half-fill':item.totalScale>=2.25 && item.totalScale<=2.75
                                }">
        </i>
        <i class="ri-star-fill" [ngClass]="{
                                    'ri-star-fill':item.totalScale>3.75, 
                                    'ri-star-line':item.totalScale<=3.24,
                                    'ri-star-half-fill':item.totalScale>=3.25 && item.totalScale<=3.75
                                }">
        </i>
        <i class="ri-star-fill" [ngClass]="{
                                    'ri-star-fill':item.totalScale>4.75, 
                                    'ri-star-line':item.totalScale<=4.24,
                                    'ri-star-half-fill':item.totalScale>=4.25 && item.totalScale<=4.75
                                }">
        </i>
    </div>
</ng-template>